// config/lims/services.ts
export const services = [
  {
    title: 'Land Survey',
    description:
      'Request professional survey services, access cadastral maps, and verify property boundaries for compliance and registration purposes.',
    imageSrc: '/lims/images/survey.svg',
  },
  {
    title: 'Land Valuation',
    description:
      'Obtain accurate valuation reports for land and property for taxation, transactions, compensation, or investment purposes.',
    imageSrc: '/lims/images/valuation.svg',
  },
  {
    title: 'Land Record Management',
    description:
      'Access, update, or verify official land records, including ownership details, titles, and transaction histories.',
    imageSrc: '/lims/images/management.svg',
  },
  {
    title: 'Land Property Management',
    description:
      'Manage property details, transfers, leases, and ownership records with streamlined approval workflows.',
    imageSrc: '/lims/images/property.svg',
  },
  {
    title: 'Land Rating',
    description:
      'Calculate and pay land rates, view outstanding balances, and access rating assessments for your parcels.',
    imageSrc: '/lims/images/rating.svg',
  },
  {
    title: 'Other Services',
    description:
      'Explore additional land-related services including amendments, approvals, and compliance certifications.',
    imageSrc: '/lims/images/services.svg',
  },
];
